import axios from "axios";
import type { AxiosResponse } from "axios";

export interface ContactMessage {
  email: string;
  subject: string;
  body: string;
  canEmailBack: boolean;
}

export function sendEmail({
  email,
  subject,
  body,
  canEmailBack
}: ContactMessage): Promise<AxiosResponse> {
  return axios.post("/.netlify/functions/send-email", {
    email,
    subject,
    body,
    canEmailBack
  });
}
